import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from 'src/app/models/form/saved-data-info';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { SettingsProjectsTestlistFormComponent } from '../../../components/settings-projects-testlist-form/settings-projects-testlist-form.component';
import { SettingsRegulationToNewTestlistComponent } from '../../../components/settings-regulation-to-new-testlist/settings-regulation-to-new-testlist.component';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';

@Component({
  selector: 'app-projects-testlist-edit-page',
  imports: [
    SettingsProjectsTestlistFormComponent,
    SettingsRegulationToNewTestlistComponent
  ],
  templateUrl: './projects-testlist-edit-page.component.html',
  styleUrl: './projects-testlist-edit-page.component.scss'
})
export class ProjectsTestlistEditPageComponent {
  testlistId!: number;
  testlist?: any;

  jurisdictionId!: number;
  lawId!: number;
  checklistId!: number;
  
  formFieldsComplete = false;
  constructor(
    private route: ActivatedRoute,
    private projectsService: ProjectsService,
    private alertNotificationService: AlertNotificationService
  ) {}

  ngOnInit(): void {
    this.testlistId = Number(this.route.snapshot.paramMap.get('testlistId'));
    if (this.testlistId) {
      this.loadData(this.testlistId);
    }
  }

  loadData(testlistId: any): void {
    this.projectsService.detailSettingsTestlist(testlistId).subscribe((response: any) => {
      this.testlist = response.data?.testlist;
      
      if (this.testlist) {
        
        if (this.testlist.jurisdictions.length > 0) {
          this.jurisdictionId =this.testlist.jurisdictions[0].jurisdictionId;
        }
        
        if (this.testlist.lawId) {
          this.lawId = this.testlist.lawId;
        }
        
        if (this.testlist.checklists) {
          this.checklistId = this.testlist.checklists[0].checklistId;
        }
        
        this.formFieldsComplete = !!(this.jurisdictionId && this.lawId && this.checklistId);
      }
    });
  }

  onProjectFormSavedData(savedDataInfo: SavedDataInfo): void {
    if (savedDataInfo.success) {
      this.alertNotificationService.success('Testlist saved successfully!');
    }
  }

  onFieldChange(event: { jurisdiction: number; law: number; checklist?: number }): void {
    this.jurisdictionId = event.jurisdiction;
    this.lawId = event.law;
    this.checklistId = event.checklist || 0;
    
    this.formFieldsComplete = !!(this.jurisdictionId && this.lawId && this.checklistId);
  }

  onRegulationsToTestlistSavedData(savedDataInfo: SavedDataInfo): void {
    if (savedDataInfo.success) {
      console.log('Testlist successfully created:', savedDataInfo.response);
    }
  }
}
